import SignInForm from "../ui/SignInForm";

export function LoginPage() {
  return (
    <div className="space-y-6">
      <div className="space-y-1.5">
        <h1 className="font-semibold text-xl tracking-tight">ເຂົ້າລະບົບ</h1>
        <p className="text-muted-foreground text-sm">
          ໃຊ້ບັນຊີພະນັກງານທີ່ໄດ້ຮັບອະນຸຍາດ
        </p>
      </div>
      <SignInForm />
    </div>
  );
}
